import { createEvent, createStore } from 'effector'

export const actions = {
  setMetiers: createEvent<ControleQualiteMetierResponse[]>('setMetiers'),
  resetMetiers: createEvent('resetMetiers'),
  reset: createEvent('reset'),
}

const initialState: MetierState = {
  metiers: [],
}

export const store = createStore<MetierState>(initialState, { name: 'metier' })
  .on(actions.setMetiers, (s, metiers) => ({ ...s, metiers }))
  .on(actions.resetMetiers, (s) => ({ ...s, metiers: initialState.metiers }))
  .reset(actions.reset)
